export default theme => ({
  page_header: {
    "text-align": "center",
    color: theme.palette.white.main,
    padding: 6,
    margin: 3,
  },
});
